import './styles/app.scss';
import './styles/style.scss';

import * as bootstrap from 'bootstrap';

import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import 'slick-carousel/slick/slick.min';

import {Application} from "@hotwired/stimulus";
import {definitionsFromContext} from "@hotwired/stimulus-webpack-helpers";
import 'tom-select/dist/css/tom-select.css';

import './js/next-slot.js';
import './js/dismiss-keyboard-on-select.js';

window.addEventListener('DOMContentLoaded', function () {
    window.Stimulus = Application.start()
    const context = require.context("./controllers", true, /\.js$/)
    Stimulus.load(definitionsFromContext(context))

    setTimeout(function () {
        if (!window.sessionStorage.getItem('landing-page')) {
            window.sessionStorage.setItem('landing-page', 'other page');
        }
    }, 2000);


    // Combined Reviews Widget Carousel (DDT-4423)
    if ($('.combined-reviews-carousel').length > 0) {
        const REVIEW_LINES = 3;

        // Cut a comment to 3 lines followed by « … Voir plus ». The cut is
        // measured, not counted in characters, so it holds at every card width.
        const truncateReview = function ($wrapper) {
            const $comment = $wrapper.find('.review-comment');
            const $readMore = $wrapper.find('.review-read-more');
            const fullText = String($comment.data('full-text') || '');
            const maxHeight = parseFloat($wrapper.css('line-height')) * REVIEW_LINES + 1;

            $comment.text(fullText);
            $readMore.addClass('d-none');

            if ($wrapper.outerHeight() <= maxHeight) {
                $wrapper.removeClass('has-more');
                return;
            }

            $readMore.removeClass('d-none');

            let low = 0;
            let high = fullText.length;

            while (low < high) {
                const middle = Math.ceil((low + high) / 2);

                $comment.text(fullText.slice(0, middle).trimEnd() + '… ');

                if ($wrapper.outerHeight() <= maxHeight) {
                    low = middle;
                } else {
                    high = middle - 1;
                }
            }

            $comment.text(fullText.slice(0, low).trimEnd() + '… ');
            $wrapper.addClass('has-more');
        };

        const truncateReviews = function () {
            $('.combined-reviews-widget .review-comment-wrapper').not('.expanded').each(function () {
                truncateReview($(this));
            });
        };

        $('.combined-reviews-widget').each(function () {
            const $widget = $(this);
            const $prev = $widget.find('.combined-reviews-arrow--prev');
            const $next = $widget.find('.combined-reviews-arrow--next');

            $widget.find('.combined-reviews-carousel').slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                prevArrow: $prev,
                nextArrow: $next,
                responsive: [
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            variableWidth: true
                        }
                    }
                ]
            });
        });

        truncateReviews();

        let reviewsResizeTimer;
        $(window).on('resize', function () {
            clearTimeout(reviewsResizeTimer);
            reviewsResizeTimer = setTimeout(truncateReviews, 150);
        });

        // Handle "Voir plus" click for review expansion
        $('.combined-reviews-widget').on('click', '.review-read-more', function(e) {
            e.preventDefault();
            e.stopPropagation(); // Prevent card link click

            const $this = $(this);
            const $wrapper = $this.closest('.review-comment-wrapper');

            if ($wrapper.hasClass('expanded')) {
                $wrapper.removeClass('expanded');
                $this.text('Voir plus');
                truncateReview($wrapper);
            } else {
                $wrapper.find('.review-comment').text($wrapper.find('.review-comment').data('full-text') + ' ');
                $wrapper.removeClass('has-more').addClass('expanded');
                $this.text('Voir moins');
            }
        });
    }

    if ($('.lawyers-carousel').length > 0) {
        $('.lawyers-carousel').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false
                    }
                }
            ]
        });
    }

    // Lawyer articles "Load more" functionality
    const articlesContainer = document.getElementById('lawyer-articles-container');
    const loadMoreBtn = document.getElementById('load-more-articles-btn');

    if (articlesContainer && loadMoreBtn) {
        loadMoreBtn.addEventListener('click', async function() {
            const lawyerId = this.dataset.lawyerId || this.getAttribute('data-lawyer-id');
            const offset = parseInt(this.dataset.offset || this.getAttribute('data-offset'), 10);
            const total = parseInt(this.dataset.total || this.getAttribute('data-total'), 10);
            const template = this.dataset.template || this.getAttribute('data-template') || 'lawyer';
            const loadingText = this.dataset.loadingText || this.getAttribute('data-loading-text') || this.textContent;

            // Show loading state
            const originalText = this.textContent;
            this.textContent = loadingText;
            this.disabled = true;

            try {
                const response = await fetch(window.jfRestUrl( `justifit/v1/lawyer-articles?lawyer_id=${lawyerId}&offset=${offset}&limit=6&template=${encodeURIComponent(template)}` ));
                if (!response.ok) throw new Error('lawyer-articles fetch failed: ' + response.status);
                
                const data = await response.json();

                if (data.html) {
                    articlesContainer.insertAdjacentHTML('beforeend', data.html);

                    // Update offset
                    const newOffset = offset + 6;
                    this.dataset.offset = newOffset;
                    this.setAttribute('data-offset', newOffset);

                    // Hide button if no more articles
                    if (newOffset >= total || !data.has_more) {
                        this.style.display = 'none';
                    }
                } else {
                    this.style.display = 'none';
                }
            } catch (error) {
                console.error('Error loading articles:', error);
                this.textContent = originalText;
                this.disabled = false;
            } finally {
                if (this.style.display !== 'none') {
                    this.textContent = originalText;
                    this.disabled = false;
                }
            }
        });
    }
});

function setCookie(e, o, t) {
    var n, c = "";
    t && ((n = new Date).setTime(n.getTime() + 24 * t * 60 * 60 * 1e3), c = "; expires=" + n.toUTCString()), window.jfCookies.set(e + "=" + (o || "") + c + "; path=/")
}

global.setCookie = setCookie;

function getCookie(e) {
    for (var o = e + "=", t = window.jfCookies.read().split(";"), n = 0; n < t.length; n++) {
        for (var c = t[n]; " " == c.charAt(0);) c = c.substring(1, c.length);
        if (0 == c.indexOf(o)) return c.substring(o.length, c.length)
    }
    return null
}

global.getCookie = getCookie;

function eraseCookie(e) {
    window.jfCookies.set(e + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;")
}

global.eraseCookie = eraseCookie;

function trackSearchResults({
    primary = 0,
    secondary = 0,
    query = null,
    filters = null,
    radius = null,
    source = null,
    remote = null,
}) {
    // DDT-3902 (Simeon): total_count stays primary + secondary — remote results
    // are deliberately in no count (ticket SEO rule). remote_count is null when
    // no remote section was rendered.
    const total = primary + secondary;

    // General search event
    dataLayer.push({
        event: "dataLayer.gaEvent",
        gaEvent: {
            category: "listing results",
            action: "count_search_results",
            label: "",
            primary_count: primary,
            secondary_count: secondary,
            total_count: total,
            remote_count: remote,
            query: query,
            filters: null === filters ? null : filters.replaceAll('&quot;', '"'),
            radius: radius,
            source: source
        }
    });

    // Zero-results event.
    // DDT-3902 (Kevin, 25/09): a page filled by remote results is NOT an empty
    // search — only fire zero_search_results when nothing at all was shown.
    if (total === 0 && !remote) {
        dataLayer.push({
            event: "dataLayer.gaEvent",
            gaEvent: {
                category: "listing results",
                action: "zero_search_results",
                label: "",
                query: query,
                filters: null === filters ? null : filters.replaceAll('&quot;', '"'),
                radius: radius,
                source: source
            }
        });
    }
}

global.trackSearchResults = trackSearchResults;

global.$ = jQuery = $;
